var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoArrowsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.052 3.9755L4.8395 9.59751C4.66469 9.78606 4.37012 9.7972 4.18157 9.62238C4.16804 9.60984 4.15528 9.59651 4.14333 9.58245L2.18893 7.28256C2.02243 7.08663 1.72862 7.06277 1.53269 7.22927C1.33676 7.39577 1.3129 7.68958 1.4794 7.88551L3.4338 10.1854C3.46963 10.2276 3.50793 10.2676 3.54851 10.3052C4.11416 10.8296 4.99786 10.7962 5.5223 10.2306L10.7348 4.60856C10.9096 4.42001 10.8985 4.12544 10.7099 3.95063C10.5214 3.77581 10.2268 3.78695 10.052 3.9755Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83869 9.59768L13.0512 3.97567C13.226 3.78712 13.5206 3.77598 13.7091 3.9508C13.8977 4.12561 13.9088 4.42018 13.734 4.60873L8.5215 10.2307C8.33812 10.4285 8.08897 10.812 7.83869 10.8486C7.51396 10.896 7.00006 10.5 7.50006 10L7.83869 9.59768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoArrowsWhite);
export default __webpack_public_path__ + "static/media/twoArrowsWhite.8cc17a2994e27d47f13ede846fbf3708.svg";
export { ForwardRef as ReactComponent };